import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/report')({
  loader: () => {
    return {
      crumb: 'Laporan',
    }
  },
})
